<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Marcas de Activos</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'af-marca-nuevo', params: {}}"
              >
                <i class="fa fa-plus"></i>
                Añadir Marca
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refresh</a>
            </div>
            <div class="col-sm-6">
              <form  class="form-inline justify-content-sm-end" @submit="filterData" >
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Buscar"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-left" >Código</th>
                <th class="text-left">Nombre</th>
                <th class="text-left">Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="current in data.results" v-bind:key="current.id" @click="rowClick(current)">
                <td class="text-left">{{ current.id }}</td>
                <td class="text-left">{{ current.nombre }}</td>
                <td class="text-left">{{ current.descripcion }}</td>
              </tr>
            </tbody>
          </table>
          <br>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";


export default {
  components: {
    PaginationComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: 1,
      data: []
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("af","marca", params).then(res => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "af-marca-editar",
        params: { id: current.id }
      });
    },
    showModalEdit() {}
  }
};
</script>
